module.exports = __webpack_public_path__ + "img/NascarBadge.0a022d65.svg";